module.exports = __webpack_public_path__ + "static/media/people.65c633d0.jpg";